import React, { useMemo } from 'react'
import TeamSwitcher from './TeamSwitcher'
import Stripe from '../../Shared/Stripe'
import './Navbar.css'

const Navbar = props => {
  const { children } = props

  const isTCIDashboard = useMemo(() => {
    return /tci/.test(window.location.pathname)
  }, [window.location.pathname])

  return (
    <div className="app-navbar">
      <Stripe className="app-navbar-stripe" />
      <div className="app-navbar-brand">Adalo</div>
      {isTCIDashboard && (
        <div className="app-navbar-brand--transcosmos">Transcosmos</div>
      )}
      {children}
      <TeamSwitcher />
    </div>
  )
}

export default Navbar

export const Spacer = () => <div className="navbar-spacer" />
